import { client } from "../client";
import { Paginated, PaginatedFilter } from "../types/axios.types";
import { UserCenter } from "../types/center.types";
import { User, UserCenterRole, UserStats } from "../types/user.types";

export const fetchMe = async () => {
	const response = await client.get<User>(`/auth/me`);
	return response.data;
};

export const fetchUser = async (id: number | string | undefined) => {
	if (id == undefined) {
		return null;
	}
	const response = await client.get<User>(`users/${id}/`);
	return response.data;
};

export const fetchUserStats = async (id: number | string | undefined) => {
	if (id == undefined) {
		return null;
	}
	const response = await client.get<UserStats>(`users/${id}/stats`);
	return response.data;
};

export const fetchUsers = async (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<User[]>>(`users/`, {
		params,
	});
	return response.data;
};

export const fetchUserCenters = async (
	id: number | string | undefined,
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	if (id == undefined) {
		return null;
	}
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<UserCenter[]>>(
		`users/${id}/centers`,
		{
			params,
		},
	);
	return response.data;
};

export const fetchAdmins = async () => {
	const response = await client.get<User[]>(`/auth/admins/`);
	return response.data;
};

export const updateMe = async (
	user: Pick<User, "email" | "firstName" | "lastName" | "phoneNumber">,
) => {
	const response = await client.patch<User>(`me/`, {
		email: user.email,
		firstName: user.firstName,
		lastName: user.lastName,
		phoneNumber: user.phoneNumber,
	});
	return response.data;
};

export const updateUser = async (
	user: Partial<User> & {
		centerId?: number | string | null;
		role?: UserCenterRole;
	},
) => {
	const response = await client.patch<User>(`users/${user.id}`, {
		email: user.email,
		firstName: user.firstName,
		lastName: user.lastName,
		phoneNumber: user.phoneNumber,
		activatedAt: user.activatedAt,
		rejectedAt: user.rejectedAt,
		centerId: user.centerId,
		role: user.role,
	});
	return response.data;
};
